export const heroSlides = [
  {
    id: 1,
    title: "2026世界杯亚洲区预选赛",
    subtitle: "精彩赛事直播 · 实时竞猜 · 高额返利",
    ctaText: "立即注册",
    ctaLink: "#",
    secondaryText: "查看赛程",
    secondaryLink: "/category/football",
  },
  {
    id: 2,
    title: "NBA季后赛激战正酣",
    subtitle: "篮球盛宴 · 每日竞猜 · 会员专属福利",
    ctaText: "立即参与",
    ctaLink: "#",
    secondaryText: "查看详情",
    secondaryLink: "/category/basketball",
  },
  {
    id: 3,
    title: "LPL夏季赛全程直播",
    subtitle: "电竞巅峰对决 · 实时数据 · 极速结算",
    ctaText: "立即投注",
    ctaLink: "#",
    secondaryText: "赛事专题",
    secondaryLink: "/category/esports",
  },
];

export const liveEvents = [
  {
    id: 1,
    league: "英超联赛",
    homeTeam: "曼联",
    awayTeam: "利物浦",
    homeScore: 2,
    awayScore: 1,
    time: "78'",
    status: "live",
    category: "football",
    viewers: 128500,
  },
  {
    id: 2,
    league: "NBA常规赛",
    homeTeam: "洛杉矶湖人",
    awayTeam: "金州勇士",
    homeScore: 98,
    awayScore: 102,
    time: "Q4 3:25",
    status: "live",
    category: "basketball",
    viewers: 95300,
  },
  {
    id: 3,
    league: "LPL夏季赛",
    homeTeam: "JDG",
    awayTeam: "BLG",
    homeScore: 2,
    awayScore: 1,
    time: "BO5 G4",
    status: "live",
    category: "esports",
    viewers: 212000,
  },
  {
    id: 4,
    league: "法网公开赛",
    homeTeam: "阿尔卡拉斯",
    awayTeam: "德约科维奇",
    homeScore: 2,
    awayScore: 1,
    time: "Set 4",
    status: "live",
    category: "tennis",
    viewers: 67400,
  },
];

export const upcomingEvents = [
  {
    id: 5,
    league: "中超联赛",
    homeTeam: "上海海港",
    awayTeam: "北京国安",
    startTime: "2026-08-09 19:35",
    category: "football",
  },
  {
    id: 6,
    league: "NBA常规赛",
    homeTeam: "波士顿凯尔特人",
    awayTeam: "密尔沃基雄鹿",
    startTime: "2026-08-09 08:00",
    category: "basketball",
  },
  {
    id: 7,
    league: "DOTA2国际邀请赛",
    homeTeam: "Team Spirit",
    awayTeam: "PSG.LGD",
    startTime: "2026-08-10 14:00",
    category: "esports",
  },
  {
    id: 8,
    league: "ATP大师赛",
    homeTeam: "辛纳",
    awayTeam: "兹维列夫",
    startTime: "2026-08-10 20:00",
    category: "tennis",
  },
];

export const categories = [
  {
    slug: "football",
    name: "足球",
    icon: "ri-football-line",
    matchCount: 1280,
    description: "全球顶级足球赛事，英超、西甲、欧冠、世界杯等全覆盖",
  },
  {
    slug: "basketball",
    name: "篮球",
    icon: "ri-basketball-line",
    matchCount: 860,
    description: "NBA、CBA、欧洲篮球联赛，实时数据同步",
  },
  {
    slug: "esports",
    name: "电竞",
    icon: "ri-gamepad-line",
    matchCount: 540,
    description: "LOL、DOTA2、CS:GO、王者荣耀等热门电竞赛事",
  },
  {
    slug: "tennis",
    name: "网球",
    icon: "ri-base-station-line",
    matchCount: 320,
    description: "大满贯、ATP、WTA巡回赛，专业数据支持",
  },
  {
    slug: "comprehensive",
    name: "综合",
    icon: "ri-medal-line",
    matchCount: 460,
    description: "乒乓球、羽毛球、排球、F1赛车等综合赛事",
  },
];

export const benefits = [
  {
    id: 1,
    icon: "ri-shield-check-line",
    title: "安全稳定",
    description: "持有国际正规牌照，资金安全有保障，采用银行级加密技术，确保用户信息与资金安全无虞",
  },
  {
    id: 2,
    icon: "ri-flashlight-line",
    title: "极速体验",
    description: "全球CDN加速节点，赛事直播低延迟，竞猜结算秒级到账，为您打造流畅无卡顿的使用体验",
  },
  {
    id: 3,
    icon: "ri-gift-line",
    title: "丰厚福利",
    description: "新用户注册即送体验金，每日签到领积分，VIP会员专享高额返水与生日礼包等多重惊喜",
  },
  {
    id: 4,
    icon: "ri-customer-service-2-line",
    title: "全天客服",
    description: "7×24小时专业客服团队在线值守，问题秒级响应，为您提供一对一的贴心服务体验",
  },
];

export const stats = [
  { value: "5000万+", label: "注册用户" },
  { value: "128+", label: "覆盖国家" },
  { value: "99.9%", label: "支付成功率" },
  { value: "30秒", label: "平均提现速度" },
];